<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
  title: {
    type: String,
    default: '',
    required: true,
  },
  isCompleted: {
    type: Boolean,
    default: false,
  },
  imageName: {
    type: String,
    default: '',
    required: false,
  },
  destinationRouteName: {
    type: String,
    default: '',
    required: false,
  },
});

const imageBind = computed(() => {
  if (props.isCompleted) return '/svg/check.svg';
  return props.imageName;
});

const routePush = () => {
  if (props.destinationRouteName && props.isCompleted) {
    router.push({ name: props.destinationRouteName });
  }
};
</script>

<template>
  <div
    class="row d-flex justify-content-between"
    @click="routePush"
  >
    <div
      v-if="imageBind"
      class="col-10"
    >
      <BaseIconWithLabel
        :image-name="imageBind"
        before
      >
        <h4>{{ title }}</h4>
      </BaseIconWithLabel>
    </div>
    <div
      v-else
      class="col-10"
    >
      <h4>{{ title }}</h4>
    </div>
    <div
      v-if="isCompleted"
      class="col-2 text-end"
    >
      <a role="button">{{ $t('general.callToActionButton.changeData') }}</a>
    </div>
  </div>
  <hr>
</template>

<style scoped lang="scss"></style>
